import React, { createContext, useContext } from "react";
import { RouteDetailElement } from "#types";

type SetContentFunction = (
  content: React.ReactNode | null,
  contentClassName?: string
) => void;

type SetVisibilityFunction = () => void;

export interface PageContextProps {
  setLeftContent: SetContentFunction;
  setRightContent: SetContentFunction;
  setFilterContent: SetContentFunction;
  setMainContent: SetContentFunction;
  setActiveRouteDetails: (activeRouteDetail: RouteDetailElement) => void;
  activeRouteDetails?: RouteDetailElement;
  hideMap: SetVisibilityFunction;
  showMap: SetVisibilityFunction;
  hideFilter: SetVisibilityFunction;
  showFilter: SetVisibilityFunction;
  showLocationFilter: SetVisibilityFunction;
  hideLocationFilter: SetVisibilityFunction;
  showHazardFilter: SetVisibilityFunction;
  hideHazardFilter: SetVisibilityFunction;
  showDataRangeFilter: SetVisibilityFunction;
  hideDataRangeFilter: SetVisibilityFunction;
}

// Default context value with no-op functions and undefined properties
const defaultContext: PageContextProps = {
  setLeftContent: () => {},
  setRightContent: () => {},
  setFilterContent: () => {},
  setMainContent: () => {},
  setActiveRouteDetails: () => {},
  activeRouteDetails: undefined,
  hideMap: () => {},
  showMap: () => {},
  hideFilter: () => {},
  showFilter: () => {},
  showLocationFilter: () => {},
  hideLocationFilter: () => {},
  showHazardFilter: () => {},
  hideHazardFilter: () => {},
  showDataRangeFilter: () => {},
  hideDataRangeFilter: () => {},
};

// Create the context
const PageContext = createContext<PageContextProps>(defaultContext);

// Optional: Custom hook for consuming the context with type safety
export const usePageContext = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error("usePageContext must be used within a PageContextProvider");
  }
  return context;
};

export default PageContext;
